<template>
    <section class="team-target section section-shaped section-lg my-0">
        <div class="shape shape-style-1 shape-default shape-skew response bg-gradient">
        </div>
        <div class="pt-lg-md" style="width: 100%; padding: 0 100px 0 100px">
            <div class="row justify-content-center">
                <v-card style="display: flex; flex-direction: row; width: 100%" class="p-4">
                    <div style="flex: 1; min-width: 0">
                        <v-text-field
                                v-model="searchInput"
                                style="width: 40%;"
                                :class="[isEN ? 'mb-3':'direction-rtl mb-3']"
                                flat
                                hide-details
                                :placeholder="language.lang('Search consultants ...')"
                                prepend-inner-icon="mdi-magnify"
                        ></v-text-field>
                        <span class="mb-5" v-if="searchInput != null && searchInput.length > 0">{{language.lang('Search result: ')}}</span>
                        <div style="display: flex; flex-wrap: wrap"
                             v-if="searchInput != null && searchInput.length > 0">
                            <v-col cols="12" md="4" v-for="(item, index) in searchList" :key="index"
                                   class="mt-1 mb-1 mr-auto" role="button"
                                   @click="$router.push({name: 'lawyer', params: {id: item.lawyer_index}})">
                                <img :src="item.lawyer_cover != null ? item.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"
                                     class="rounded-circle img-center img-fluid shadow shadow-lg--hover center_cropped"
                                     style="width: 150px; height: 150px">
                                <div class="pt-4 text-center">
                                    <h5 class="title title-text">
                                        <span style="font-size: 15px" class="font-weight-bold d-block mb-1">{{item.lawyer_title}}</span>
                                        <small class="h6 text-muted">{{item.lawyer_brief}}</small>
                                    </h5>
                                    <div v-if="item.lawyer_contact_public != null"
                                         class="row mt-3 mb-3 mr-auto ml-auto text-default">
                                        <div class="ml-auto"></div>
                                        <i @click="oracle.newTab(item.lawyer_contact_public.facebook)"
                                           v-if="!oracle.isEmpty(item.lawyer_contact_public.facebook)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-facebook badge-circle"></i>
                                        <i @click="oracle.newTab(item.lawyer_contact_public.twitter)"
                                           v-if="!oracle.isEmpty(item.lawyer_contact_public.twitter)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-twitter badge-circle"></i>
                                        <i @click="oracle.newTab(item.lawyer_contact_public.instagram)"
                                           v-if="!oracle.isEmpty(item.lawyer_contact_public.instagram)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-instagram badge-circle "></i>
                                        <i @click="oracle.newTab(item.lawyer_contact_public.youtube)"
                                           v-if="!oracle.isEmpty(item.lawyer_contact_public.youtube)"
                                           style="width: 25px; height: 25px; font-size: 20px"
                                           class="m-1 fa fa-youtube badge-circle "></i>
                                        <div class="mr-auto"></div>
                                    </div>
                                </div>
                            </v-col>
                        </div>
                        <v-tabs :show-arrows="false"
                                class="mb-3" v-if="searchInput == null || searchInput.length == 0"
                                v-model="tab"
                                align-with-title>
                            <v-tabs-slider color="#42C7D5;"></v-tabs-slider>
                            <v-tab v-for="(model, i) in items" :key="i" :href="'#tab-' + i">
                                {{ model.visa_title }}
                            </v-tab>
                        </v-tabs>
                        <v-tabs-items v-if="searchInput == null || searchInput.length == 0" v-model="tab">
                            <v-tab-item v-for="(tab, j) in items" :key="j" :value="'tab-' + j">
                                <div style="display: flex; flex-wrap: wrap"
                                     v-if="tab.lawyers != null && tab.lawyers.length > 0">
                                    <v-col cols="12" md="4" v-for="(item, index) in tab.lawyers" :key="index"
                                           class="mt-1 mb-1 mr-auto"
                                           @click="$router.push({name:'lawyer', params: {id: item.lawyer_index}})">
                                        <img :src="item.lawyer_cover != null ? item.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"
                                             class="rounded-circle img-center img-fluid shadow shadow-lg--hover center_cropped"
                                             style="width: 150px; height: 150px">
                                        <div class="pt-4 text-center">
                                            <h5 class="title title-text">
                                                <span style="font-size: 15px" class="font-weight-bold d-block mb-1">{{item.lawyer_title}}</span>
                                                <small class="h6 text-muted">{{item.lawyer_brief}}</small>
                                            </h5>
                                            <div v-if="item.lawyer_contact_public != null"
                                                 class="row mt-3 mb-3 mr-auto ml-auto text-default">
                                                <div class="ml-auto"></div>
                                                <i @click="oracle.newTab(item.lawyer_contact_public.facebook)"
                                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.facebook)"
                                                   style="width: 25px; height: 25px; font-size: 20px"
                                                   class="m-1 fa fa-facebook badge-circle"></i>
                                                <i @click="oracle.newTab(item.lawyer_contact_public.twitter)"
                                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.twitter)"
                                                   style="width: 25px; height: 25px; font-size: 20px"
                                                   class="m-1 fa fa-twitter badge-circle"></i>
                                                <i @click="oracle.newTab(item.lawyer_contact_public.instagram)"
                                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.instagram)"
                                                   style="width: 25px; height: 25px; font-size: 20px"
                                                   class="m-1 fa fa-instagram badge-circle "></i>
                                                <i @click="oracle.newTab(item.lawyer_contact_public.youtube)"
                                                   v-if="!oracle.isEmpty(item.lawyer_contact_public.youtube)"
                                                   style="width: 25px; height: 25px; font-size: 20px"
                                                   class="m-1 fa fa-youtube badge-circle "></i>
                                                <div class="mr-auto"></div>
                                            </div>
                                        </div>
                                    </v-col>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                    <div :class="isEN ? 'ml-5' : 'mr-5'"
                         style="width: 1px; height: 100%; background-color: lightgray"></div>
                    <div class="ml-3 mr-2" style="width: auto; height: auto;">
                        <h5 class="ml-3 mr-3 font-weight-bold">{{language.lang(`Filter Consults:`)}}</h5>
                        <v-card-text>
                            <div class="d-flex flex-column" style="width: 300Px;">
                                <v-select :items="services" multiple
                                          item-text="abbr"
                                          @change="submitFilter" item-value="state"
                                          v-model="filter.lawyer_services"
                                          :label="language.lang('Services')"
                                          :hint="language.lang('Filter your services')"
                                          persistent-hint>

                                </v-select>
                                <v-select :items="languages" multiple
                                          @change="submitFilter" v-model="filter.lawyer_languages"
                                          :label="language.lang('Languages')"
                                          :hint="language.lang('Filter your languages')"
                                          persistent-hint>

                                </v-select>
                                <v-select :items="specializations" multiple
                                          @change="submitFilter" item-text="abbr"
                                          item-value="state"
                                          v-model="filter.lawyer_specializations"
                                          :label="language.lang('Specializations')"
                                          :hint="language.lang('Filter your specializations')"
                                          persistent-hint>

                                </v-select>
                                <div class="border-bottom mt-3"></div>
                                <v-checkbox @change="submitFilter" :label="language.lang('Only Verified Consultants')"
                                            v-model="filter.lawyer_verified"></v-checkbox>
<!--                                <v-checkbox @change="submitFilter" :label="language.lang('Office in Canada')"-->
<!--                                            v-model="filter.lawyer_location_canada"></v-checkbox>-->
<!--                                <v-checkbox @change="submitFilter" :label="language.lang('Office in Iran')"-->
<!--                                            v-model="filter.lawyer_location_iran"></v-checkbox>-->
                            </div>
                        </v-card-text>
                    </div>
                </v-card>
            </div>
        </div>
    </section>
</template>
<script>
    import oracle from "@/utils/oracle";
    import language from "@/utils/language";

    export default {
        name: "teams",
        data: () => ({
            searchList: [],
            searchAll: [],
            items: [],
            all: [],
            isEN: oracle.isEN(),
            searchInput: null,
            language: language,
            views: [],
            tops: [],
            oracle: oracle,
            tab: null,
            filter: {},
            languages: ['فارسی', 'English', 'Français', 'हिन्दी', '中国人', 'pilipino', 'Türkçe'],
            specializations: [
                {state: 'Investment and Business Visas', abbr: language.lang('Investment and Business Visas')},
                {state: 'Work Visas', abbr: language.lang('Work Visas')},
                {state: 'Express Entry', abbr: language.lang('Express Entry')},
                {state: 'Visitor & Tourism Visas', abbr: language.lang('Visitor & Tourism Visas')},
                {state: 'PNP', abbr: language.lang('PNP')},
                {state: 'Family & sponsorship Visas', abbr: language.lang('Family & sponsorship Visas')},
                {state: 'Study & Training Visas', abbr: language.lang('Study & Training Visas')},
            ],
            services: [
                {state: 'Free Consultation', abbr: language.lang('Free Consultation')},
                {state: 'Fast Reply', abbr: language.lang('Fast Reply')},
                {state: 'Insured', abbr: language.lang('Professional Insurance')}
            ]
        }), methods: {
            checkFilterable(lawyer) {
                if (this.filter != null) {
                    if (this.filter.lawyer_verified != null && this.filter.lawyer_verified) {
                        if (!lawyer.lawyer_verified) {
                            return
                        }
                    }
                    if (this.filter.lawyer_specializations != null && this.filter.lawyer_specializations.length > 0) {
                        if (lawyer.lawyer_specializations != null && lawyer.lawyer_specializations.length > 0) {
                            for (let j = 0; j < this.filter.lawyer_specializations.length; j++) {
                                let found = false
                                for (let i = 0; i < lawyer.lawyer_specializations.length; i++) {
                                    if (this.filter.lawyer_specializations[j] == lawyer.lawyer_specializations[i]) {
                                        found = true
                                        break
                                    }
                                }
                                if (!found) {
                                    return
                                }
                            }
                        } else {
                            return
                        }
                    }
                    if (this.filter.lawyer_languages != null && this.filter.lawyer_languages.length > 0) {
                        if (lawyer.lawyer_languages != null && lawyer.lawyer_languages.length > 0) {
                            for (let j = 0; j < this.filter.lawyer_languages.length; j++) {
                                let found = false
                                for (let i = 0; i < lawyer.lawyer_languages.length; i++) {
                                    if (this.filter.lawyer_languages[j] == lawyer.lawyer_languages[i]) {
                                        found = true
                                        break
                                    }
                                }
                                if (!found) {
                                    return
                                }
                            }
                        } else {
                            return
                        }
                    }
                    if (this.filter.lawyer_services != null && this.filter.lawyer_services.length > 0) {
                        if (lawyer.lawyer_services != null && lawyer.lawyer_services.length > 0) {
                            for (let j = 0; j < this.filter.lawyer_services.length; j++) {
                                let found = false
                                for (let i = 0; i < lawyer.lawyer_services.length; i++) {
                                    if (this.filter.lawyer_services[j] == lawyer.lawyer_services[i]) {
                                        found = true
                                        break
                                    }
                                }
                                if (!found) {
                                    return
                                }
                            }
                        } else {
                            return
                        }
                    }
                }
                return lawyer;
            },
            submitFilter() {
                this.searchList = []
                for (let j = 0; j < this.searchAll.length; j++) {
                    let data = this.checkFilterable(this.searchAll[j]);
                    if (data != null) this.searchList.push(data)
                }
                for (let i = 0; i < this.all.length; i++) {
                    this.items[i].lawyers = []
                    for (let j = 0; j < this.all[i].lawyers.length; j++) {
                        let data = this.checkFilterable(this.all[i].lawyers[j]);
                        if (data != null) this.items[i].lawyers.push(data)
                    }
                }
            }
        }, watch: {
            searchInput: function (to, from) {
                if (to.length > 0) {
                    oracle.axios('lawyer/getRawList', {
                        search_by: to,
                        order_by: 'priority',
                        limit_by: 100
                    }, (response) => {
                        this.searchAll = response.data
                        this.submitFilter()
                    })
                }
            },
        },
        mounted() {
            oracle.axios('lawyer/getRawList', {
                order_by: 'priority',
                limit_by: 150
            }, (res) => {
                let lawyers = res.data
                oracle.axios('lawyer/getList', {order_by: 'priority', limit_by: 150}, (response) => {
                    let array = [{
                        'visa_id': null,
                        lawyers: lawyers,
                        'visa_title': this.language.lang(`All consultant`)
                    }]
                    for (let i = 0; i < response.data.length; i++) {
                        array.push(response.data[i])
                    }
                    this.all = array
                    this.items = oracle.copy(array)
                    this.submitFilter()
                })
            })
            oracle.axios('blog/getList', {order_by: 'priority', limit_by: 3}, (response) => {
                this.tops = response.data
            })
            oracle.axios('blog/getList', {order_by: 'blog_views', limit_by: 3}, (response) => {
                this.views = response.data
            })
        }
    };
</script>
<style>
    .direction-rtl {
        direction: rtl;
    }

    .team-target .v-messages {
        min-height: 0 !important;
    }
</style>
